var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-comps-security",attrs:{"data-tips":_vm.$t('headerTools.mktHeader.90khcs')}},[_c('Icon',{attrs:{"type":"security"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }